// extracted by mini-css-extract-plugin
module.exports = {"titles":"documents_titles__2VCAV","codes":"documents_codes__3YEu7"};